import{gql as e}from"@apollo/client";const t=e`
  mutation updateUser($email: String!, $firstName: String!, $lastName: String!, $phoneNumber: String!) {
    user {
      updateEmail(email: $email)
      updateUser(firstname: $firstName, lastname: $lastName)
      updatePhoneNumber(phoneNumber: $phoneNumber)
    }
  }
`;export{t as UPDATE_USER_MUTATION};
//# sourceMappingURL=useUpdateUser.graphql.js.map
